import React, { ReactNode } from "react";

interface Props {
  onSubmit?: () => void;
  children?: ReactNode;
}

export const Form = ({ onSubmit, children }: Props) => (
  <form
    onSubmit={evt => {
      evt.preventDefault();
      onSubmit && onSubmit();
    }}
    {...{ children }}
  />
);
